<template>
  <div>
    <AuthHeading
        title="Reset the password"
        :sub-title="resetPasswordHandlerSubTitle"
    />
    <AuthForm is-reset-password-set-password />
  </div>
</template>

<script>
import AuthHeading from '@/components/auth/AuthHeading';
import AuthForm from '@/components/auth/AuthForm';

export default {
  components: {
    AuthHeading,
    AuthForm,
  },
  computed: {
    resetPasswordHandlerSubTitle() {
      return `for ${this.$route.query.email}`;
    },
  },
};
</script>

<style scoped>
</style>
